import React, { Fragment } from "react";
import { Row, Col, CardBody, Button } from "reactstrap";
import { withRouter } from "react-router-dom";
import { Tabs, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import BootstrapTable from "react-bootstrap-table-next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useGetUserTransactionsQuery, useRefundTransactionMutation } from "../../../../store/api/userManagementApi";
import Loader from "../../../common/Loader";
import { toast } from "react-toastify";
import '../styles.css';
import { useSelector } from "react-redux";

const TransactionsList = () => {
    console.log("Rendering TransactionsList");
    const userData = useSelector(state => state.userManagement.userData) || {};
    const user_id = userData?.user_id;
    const { data: transactionResponse, isLoading } = useGetUserTransactionsQuery(user_id, {
        skip: !user_id
    });
    const data = transactionResponse?.data || [];
    const [refundTransaction, { isLoading: isRefunding }] = useRefundTransactionMutation();

    const handleRefund = async (row) => {
        try {
            const response = await refundTransaction({
                user_subscription_id: row.user_subscription_id,
                transaction_id: row.transaction_id
            }).unwrap();
            
            if (response?.success) {
                toast.success("Refund initiated successfully");
            } else {
                toast.error(response?.message || "Failed to process refund");
            }
        } catch (error) {
            console.error("Refund error:", error);
            toast.error(error?.data?.message || "Error processing refund");
        }
    };

    const handleCopyReceiptId = (productid) => {
        navigator.clipboard.writeText(productid);
        toast.success("Receipt ID copied to clipboard");
    };

    const expandRow = {
        renderer: (row) => {
            return (
                <div style={{ padding: '10px' }}>
                    <span style={{ color: 'red', fontWeight: 'bold' }}>Receipt ID:</span>
                    <div
                        onClick={() => handleCopyReceiptId(row.productid)}
                        style={{ display: 'inline', cursor: 'pointer', margin: '0 0 0 1rem' }}
                    >
                        <FontAwesomeIcon icon="copy" title="Copy Receipt ID" />
                    </div>
                    <p style={{ fontWeight: '800', wordBreak: 'break-all', maxWidth: '80vw', margin: '10px 0 0 0' }}>
                        {row.productid}
                    </p>
                </div>
            );
        }
    };

    const columns = [
        {
            dataField: 'date',
            text: 'Date',
            classes: 'border-0 align-middle',
            headerClasses: 'border-0',
            sort: true,
            footer: '',
        },
        {
            dataField: 'subscription_name',
            text: 'Subscription',
            classes: 'border-0 align-middle',
            headerClasses: 'border-0',
            sort: true,
            footer: '',
        },
        {
            dataField: 'productid',
            text: 'Receipt ID',
            classes: 'border-0 align-middle',
            headerClasses: 'border-0',
            sort: true,
            footer: '',
            style: {
                maxWidth: '20ch',
                display: 'inline-block',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            }
        },
        {
            dataField: 'transaction_type',
            text: 'Transaction Type',
            classes: 'border-0 align-middle',
            headerClasses: 'border-0',
            sort: true,
            footer: '',
        },
        {
            dataField: 'mode_payment',
            text: 'Mode Of Payment',
            classes: 'border-0 align-middle',
            headerClasses: 'border-0',
            sort: true,
            footer: '',
        },
        {
            dataField: 'device',
            text: 'Device',
            classes: 'border-0 align-middle',
            headerClasses: 'border-0',
            sort: true,
            footer: '',
        },
        {
            dataField: 'amount',
            text: 'Amount',
            classes: 'border-0 align-middle',
            headerClasses: 'border-0',
            sort: true,
            footer: ''
        },
        {
            dataField: 'status',
            text: 'Status',
            classes: 'border-0 align-middle',
            headerClasses: 'border-0',
            sort: true,
            footer: '',
        },
        {
            dataField: 'refund',
            text: 'Action',
            classes: 'border-0 align-middle',
            headerClasses: 'border-0',
            footer: '',
            formatter: (cell, row) => {
                if (row.status === "success" && [1, 2].includes(row.subscription_transaction_type) && row.amount > 0) {
                    return (
                        <Button
                            color="danger"
                            size="sm"
                            onClick={() => handleRefund(row)}
                            title="Initiate Refund"
                            disabled={isRefunding}
                        >
                            {isRefunding ? 'Processing...' : 'Refund'}
                        </Button>
                    );
                }
                return <span className="text-muted">-</span>;
            },
        },
    ];

    if (isLoading) {
        return <Loader />;
    }

    return (
        <>
            <div className="d-flex justify-content-between align-items-center">
                <h4 className="section-heading">Transaction History</h4>
            </div>

            <CardBody className="bg-light">
                <Tabs>
                    <TabPanel>
                        <Row noGutters style={{ margin: "3rem 0 0 0" }}>
                            <Col lg={12} className="pr-lg-3">
                                {data && data.length > 0 ? (
                                    <Fragment>
                                        <div className="table-responsive">
                                            <BootstrapTable
                                                bootstrap4
                                                keyField="id"
                                                data={data?.map((element, index) => ({
                                                    ...element,
                                                    slno: index + 1
                                                }))}
                                                columns={columns}
                                                bordered={true}
                                                condensed={true}
                                                hover={true}
                                                tabIndexCell={true}
                                                striped={true}
                                                search={true}
                                                expanded={true}
                                                expandable={true}
                                                searchable={true}
                                                expandRow={expandRow}
                                                classes="table-dashboard table-sm fs--1 border-bottom border-200 mb-0 table-dashboard-th-nowrap"
                                                rowClasses="btn-reveal-trigger border-top border-200"
                                                headerClasses="bg-200 text-900 border-y border-200"
                                            />
                                        </div>
                                    </Fragment>
                                ) : (
                                    <div className="text-center py-5">
                                        <p className="text-muted">No transaction data found</p>
                                    </div>
                                )}
                            </Col>
                        </Row>
                    </TabPanel>
                </Tabs>
            </CardBody>
        </>
    );
};

export default withRouter(TransactionsList);
